'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemAnnotationInput = require('./components/ItemAnnotationInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemAnnotationInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-annotation-input/index.js
// module id = 918
// module chunks = 0